import axios from "axios";
import { settings } from "../helpers/settings";
import authGoogleTokenHeader from "../helpers/functions/auth-google-token-header";

const API_URL = settings.apiURL;

// Get Google APIs token
export const postGoogleApisToken = async () => {
  try {
    const respGoogleDriveToken = await axios.get(
      `${API_URL}/generateApiToken.php`
    );
    return respGoogleDriveToken.data.access_token;
  } catch (err) {
    throw err;
  }
};

// Get drive print files (folders)
export const getDrivePrintFiles = () => {
  return axios.get(`${API_URL}/listNewPrintFilesFolder.php`, {
    headers: authGoogleTokenHeader(),
  });
};

// Get drive selected date files
export const getDriveSelectedDate = (folderId) => {
  return axios.get(`${API_URL}/listSubFolders.php?folderId=${folderId}`, {
    headers: authGoogleTokenHeader(),
  });
};

// Get user files
export const getUserFiles = (user_id) => {
  return axios.get(`${API_URL}/get_user_files.php?user_id=${user_id}`);
};

// Upload to server
export const uploadToServer = (user_id, folderName, file, driveDateFolder) => {
  const formData = new FormData();
  formData.append("dosya", file);

  return axios.post(
    `${API_URL}/uploadToServer.php?user_id=${user_id}&folderName=${folderName}&driveDateFolder=${driveDateFolder}`,
    formData
  );
};

// Upload to drive
export const uploadToDrive = (temp_id, temp_path, folderId, folderName) => {
  return axios.post(
    `${API_URL}/uploadToDrive.php?temp_id=${temp_id}&folderName=${folderName}&folderId=${folderId}&temp_path=${temp_path}`,
    null,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("googleApisToken")}`,
      },
    }
  );
};

// Check file
export const checkFile = (temp_id, fileId, temp_path) => {
  return axios.get(
    `${API_URL}/checkFile.php?tempId=${temp_id}&fileId=${fileId}&temp_path=${temp_path}`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("googleApisToken")}`,
      },
    }
  );
};

// Delete file
export const deleteFile = (fileId) => {
  return axios.delete(`${API_URL}/deleteFile.php?fileId=${fileId}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("googleApisToken")}`,
    },
  });
};

// Legacy function - kept for backward compatibility but not used
export const uploadFiles = async (
  folderId,
  filesWithHeight,
  user_id,
  folderName
) => {
  const promises = [];

  filesWithHeight.forEach(({ file, height }) => {
    const formData = new FormData();
    formData.append("dosyalar[]", file);
    formData.append("heights[]", height);

    const promise = axios.post(
      `${API_URL}/uploadFiles.php?folderId=${folderId}&user_id=${user_id}&folderName=${folderName}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("googleApisToken")}`,
        },
      }
    );

    promises.push(promise);
  });

  try {
    const resp = await Promise.all(promises);
    return resp;
  } catch (error) {
    throw error;
  }
};
